module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei8.svg";